export interface Service {
  id: string
  title: string
  summary: string
  details: string[]
  image: string
  imageAlt: string
}

export const services: Service[] = [
  {
    id: 'peinture',
    title: 'Peinture intérieure et extérieure',
    summary:
      "Murs, plafonds, boiseries, façades : une préparation soignée et des finitions nettes, sans reprise ni coulure.",
    details: ['Préparation et protection', 'Enduit et sous-couche', 'Peinture mate, satinée ou laquée', 'Façades et volets'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8b5e9a8a-7735-4d16-a5d3-2f75831795f6.jpg',
    imageAlt: "Rouleau appliquant une peinture mate sur un mur intérieur, avec une ligne de coupe nette le long d'une plinthe blanche",
  },
  {
    id: 'finition',
    title: 'Travaux de finition dans le bâtiment',
    summary:
      "Le détail qui fait la différence : rebouchage, enduits, ponçage, angles et raccords parfaitement dressés.",
    details: ['Rebouchage et enduit de lissage', 'Ponçage et dressage des angles', 'Pose de plinthes et baguettes', 'Reprises après travaux'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/beb6a6f6-1c14-4a40-981a-76db727cf8b7.jpg',
    imageAlt: "Artisan lissant un enduit à la spatule dans l'angle d'un mur en chantier",
  },
  {
    id: 'vitrerie',
    title: 'Vitrerie',
    summary:
      "Remplacement de vitrage, dépannage après casse et pose sur mesure, avec une prise en charge rapide.",
    details: ['Remplacement de vitre cassée', 'Simple et double vitrage', 'Miroirs et vitrages sur mesure', 'Mastic et joints'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8354c571-1191-48fe-ae85-d86e8a4ee98b.jpg',
    imageAlt: "Vitrier posant une vitre neuve dans un châssis de fenêtre en bois",
  },
  {
    id: 'renovation',
    title: 'Rénovation et remise en état de logements',
    summary:
      "Appartement à rafraîchir, logement locatif à remettre en état : un seul interlocuteur du premier au dernier jour.",
    details: ['Rafraîchissement complet', 'Remise en état locative', 'Coordination des corps de métier', 'Nettoyage de fin de chantier'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cc9dbcfe-704c-41b4-90e5-0453536d9faf.jpg',
    imageAlt: 'Pièce fraîchement rénovée avec murs peints et parquet remis en état',
  },
]
